$(document).ready(function() {
  if ($(window).width() < 767) {
    $('.mb-popup').addClass('form-popup white-popup mfp-with-anim mfp-hide');
 }
 
    $('.slider-logo').slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        speed: 500,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1500,
        focusOnSelect: false,
        pauseOnHover: false,
        loop: true,

        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: true
            }
          },
          
         
          {
            breakpoint: 767,
            settings: {
              centerMode: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });


      $('.folks-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        arrows: false,
        dots:false,
        asNavFor: '.folks-nav',

        
      });
    
      $('.folks-nav').slick({
        slidesToShow: 4.05,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.folks-for',
        dots: true,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          
         
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      });

    


    
var svgContainer = document.querySelector('.bodymovinanim');
    var animItem = bodymovin.loadAnimation({
      wrapper: svgContainer,
      animType: 'svg',
      loop: true,
      path: "./animation/Homepage-Illustration.json"
    });



});


$('.form').on('submit', function(e) {
  e.preventDefault();
  var $valid = $(this).parsley().isValid();

  var $sucess = `<div class="form-success-message form-success-message--popup">
                <div class="form-success-message__img mx-auto">
                  <div class="z-2 mb-3"><img class="img-fluid mb-2" src="./img/success.svg">
                    <h2 class="fw-500 c-g775 mt-1">All set</h2>
                  </div>
                </div><div class="form-success-message__info col-md-6 mx-auto">
                  <p class="f-16 mb-3">You'll be one of the first to know when we go live! </p>
                  <p class="f-14">In the meantime, We'll send you bite-sized updates to help you get familiar with SafeGold and our latest product. Stay tuned!</p>
                </div></div>`;

  if($valid) {

    $(this).parents('.form-template').addClass('d-none');
    $(this).parents('.sec-form').find('.form-success-message').removeClass('d-none');

    if ($(window).width() < 767) {
      $(this).parents('.mb-popup').find('.js-sucess-message').html('');
      $(this).parents('.mb-popup').find('.js-sucess-message').html($sucess);
      $(this).addClass('d-none');
   }
    
  }
});


$(window).scroll(function() {
  var scroll = $('.sec-scroll');
  var windscroll = $(window).scrollTop();
  if(scroll.length){
    var itemscroll = $('.sec-scroll').offset().top;
  }
  
  if (windscroll >= itemscroll) {

    $('.sec-scroll__item').each(function(i) {
      // The number at the end of the next line is how pany pixels you from the top you want it to activate.
      if ($(this).position().top <= windscroll - 300) {
        var itemlen = $(this).index();
       
        $('.sg-month-list').find('.sg-month-list__item').removeClass('active');
       $('.sg-month-list').find('.sg-month-list__item').eq(itemlen).addClass('active');

       $('.sg-month-info').find('.sg-month-info__item').removeClass('active');
       $('.sg-month-info').find('.sg-month-info__item').eq(itemlen).addClass('active');

       $('.sg-month-img').find('.sg-month-img__item').removeClass('active');
       $('.sg-month-img').find('.sg-month-img__item').eq(itemlen).addClass('active');

       if(itemlen == 6) {
         $('.let-pic').addClass('d-none');
         $('.sg-month-list').addClass('op-0');
       }

       else {
        $('.let-pic').removeClass('d-none');
        $('.sg-month-list').removeClass('op-0');
       }
      }
    });

  } 
  
  else {
    $('.sg-month-list').find('.sg-month-list__item').removeClass('active');
       $('.sg-month-list').find('.sg-month-list__item').eq(0).addClass('active');

       $('.sg-month-info').find('.sg-month-info__item').removeClass('active');
       $('.sg-month-info').find('.sg-month-info__item').eq(0).addClass('active');

       $('.sg-month-img').find('.sg-month-img__item').removeClass('active');
       $('.sg-month-img').find('.sg-month-img__item').eq(0).addClass('active');

  }

  }).scroll();


  $('body').on('click', '.sg-month-list__item', function() {
    var $index = $(this).index();
    var $nextsec = $('.sec-scroll__item').eq($index);
   
    $('.sg-month-list').find('.sg-month-list__item').removeClass('active');
    $('.sg-month-list').find('.sg-month-list__item').eq($index).addClass('active');

    $('.sg-month-info').find('.sg-month-info__item').removeClass('active');
    $('.sg-month-info').find('.sg-month-info__item').eq($index).addClass('active');

    $('.sg-month-img').find('.sg-month-img__item').removeClass('active');
    $('.sg-month-img').find('.sg-month-img__item').eq($index).addClass('active');
    $('html, body').animate({ scrollTop: $($nextsec).offset().top - 300 }, 0);

  });

  $('body').on('click', '.read-more', function() {
    $(this).parents('.read-text').find('.text-more').slideDown();
    $(this).parents('.read-text').find('.text-less').slideUp();
  });

  $('body').on('click', '.read-less', function() {
    $(this).parents('.read-text').find('.text-more').slideUp();
    $(this).parents('.read-text').find('.text-less').slideDown();
  });

  $(".folks-nav").on("beforeChange", function (){
    $('.text-more').slideUp();
    $('.text-less').slideDown();
  })

  $('body').on('click', '.btn-check-status', function() {
    $(this).parents('.form').find('input[type="checkbox"]').attr('data-parsley-excluded', "true");
  });

  
  $('body').on('click', '.btn-join-wiatlist', function() {
    $(this).parents('.form').find('input[type="checkbox"]').attr('data-parsley-excluded', "false");
  });



  // Inline popups
$('.inline').magnificPopup({
  delegate: 'a',
  duration: 300,
  removalDelay: 500, //delay removal by X to allow out-animation
  callbacks: {
    beforeOpen: function() {
       this.st.mainClass = this.st.el.attr('data-effect');
       $('html').addClass('mfp-active');
    },

 
		beforeClose: function() {
			$('html').removeClass('mfp-active');
		}
  },
  midClick: true // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.
});
